import { ComponentVariant } from 'src/modules/shared/types/component.type';

export const baseLinkClasses = [
  'transition-colors',
  'duration-150',
  'inline-flex',
  'flex-wrap',
  'items-center',
  'gap-1',
  'align-baseline',
];

export const linkUnderlineClasses: Record<'none' | 'hover' | 'always', string> =
  {
    none: '',
    hover: 'hover:underline underline-offset-2',
    always: 'underline underline-offset-2',
  };

export const linkVariantClasses: Record<ComponentVariant, string> = {
  primary: 'text-primary-700 hover:text-primary-600',
  secondary: 'text-secondary-700 hover:text-secondary-600',
  neutral: 'text-neutral-600 hover:text-neutral-700',
  danger: 'text-danger-700 hover:text-danger-600',
  warning: 'text-warning-700 hover:text-warning-600',
  success: 'text-success-700 hover:text-success-600',
  info: 'text-info-700 hover:text-info-600',
  whatsapp: 'text-whatsapp-700 hover:text-whatsapp-600',
  call: 'text-call-700 hover:text-call-600',
  email: 'text-email-700 hover:text-email-600',
};
